import AppConfig from "../../config/AppConfig";
var APIWelfareConfig = {
    endpoint: AppConfig.webServerWelfare+"/api",
    url: (path) => APIWelfareConfig.endpoint + path
};

export default APIWelfareConfig;